import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loanlogics-pricing-service-fee-setup',
  templateUrl: './loanlogics-pricing-service-fee-setup.component.html',
  styleUrls: ['./loanlogics-pricing-service-fee-setup.component.css']
})
export class LoanlogicsPricingServiceFeeSetupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
